import {
  enableProdMode,
  ErrorHandler,
  importProvidersFrom,
} from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { playerFactory } from './app/app.module';
import { environment } from './environments/environment';
import { AppComponent } from './app/app.component';
import { A11yModule } from '@angular/cdk/a11y';
import { provideLottieOptions  } from 'ngx-lottie';
import { MatInputModule } from '@angular/material/input';
import { MatNativeDateModule } from '@angular/material/core';
import {  MatFormFieldModule } from '@angular/material/form-field';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { NgxPrintModule } from 'ngx-print';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from './app/app-routing.module';
import { provideAnimations } from '@angular/platform-browser/animations';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { FolioValuePipe } from './app/_pipes/folio-value.pipe';
import { QuickLockService } from './app/services/quick-lock.service';
import { UndefinedVariableInterceptor } from './app/interceptors/undefined-variable/undefined-variable.interceptor';
import { HttpserviceInterceptor } from './app/interceptors/http-interceptors/http.interceptor';
import { HTTP_INTERCEPTORS, withInterceptorsFromDi, provideHttpClient } from '@angular/common/http';
import { DatePipe } from '@angular/common';
import { QuickPayMetricsService } from './app/services/quick-pay-metrics/quick-pay-metrics.service';
import { UserInfoService } from './app/services/user-info-service.service';
import { SendMetricService } from './app/services/send-metric.service';
import { SessionServiceService } from './app/services/session-timeout/session-service.service';
import { DataBusService } from './app/services/data-bus/data-bus.service';
import { UsergaurdService } from './app/services/usergaurd/usergaurd.service';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(
      BrowserModule,
      AppRoutingModule,
      FormsModule,
      ReactiveFormsModule,
      NgxPrintModule,
      MatDatepickerModule,
      MatFormFieldModule ,
      MatNativeDateModule,
      MatInputModule,
      A11yModule,
    ),
    provideLottieOptions({
      player: () => import('lottie-web'),
    }),
    UsergaurdService,
    DataBusService,
    SessionServiceService,
    SendMetricService,
    UserInfoService,
    QuickPayMetricsService,
    DatePipe,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpserviceInterceptor,
      multi: true,
    },
    { provide: ErrorHandler, useClass: UndefinedVariableInterceptor },
    QuickLockService,
    FolioValuePipe,
    provideAnimations(),
    provideHttpClient(withInterceptorsFromDi()),
  ],
}).catch((err) => console.error(err));
